import Vue from 'vue';
import VueRouter from 'vue-router';
import { MAP_SETTINGS } from '@/constants/gmaps.js';

Vue.use(VueRouter);

const TestX = {
  template: '<div></div>'
};

const routes = [
  {
    path: '/',
    redirect: {
      name: 'base',
      params: {
        phase: -1,
        lat: MAP_SETTINGS.center.lat,
        lng: MAP_SETTINGS.center.lng,
        zoom: MAP_SETTINGS.zoom,
        mapTypeId: MAP_SETTINGS.mapTypeId,
        sidebarRight: true,
        sidebarLeft: true,
        phasesTimeline: true,
        layers: true,
        activeLayers: JSON.stringify([]),
        activeLayersOpacity: JSON.stringify([]),
        openTexts: JSON.stringify([]),
        openSettings: JSON.stringify([]),
        openPinLayers: JSON.stringify([]),
        openPins: JSON.stringify([])
      }
    }
  },
  {
    path:
      '/:phase@:lat,:lng,:zoom,:mapTypeId;:sidebarRight,:sidebarLeft,:phasesTimeline,:layers;:activeLayers',
    name: 'baseOld',
    component: TestX
  },
  {
    path:
      '/:phase@:lat,:lng,:zoom,:mapTypeId;:sidebarRight,:sidebarLeft,:phasesTimeline,:layers-:activeLayers-:activeLayersOpacity-:openTexts-:openSettings-:openPinLayers-:openPins',
    name: 'base',
    component: TestX
  }
];

const router = new VueRouter({
  routes
});

export default router;
